import JsxHelper from '../../../Helpers/JsxHelper';
import React from 'react';
import CountryText from '../../../Elements/CountryText';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import LongText from '../../../Elements/LongText';
import ThirdPartyJobPaymentsItem from './ThirdPartyJobPaymentsItem';
import LookupText from '../../../Elements/LookupText';

export default class ThirdPartyJobPaymentsAdminItem extends ThirdPartyJobPaymentsItem {
  static nameOfTheItemDetailList() {
    return 'Third Party Job Payment';
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          ThirdPartyJobPaymentsAdminItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={ThirdPartyJobPaymentsAdminItem.selectedStatus()}
        onChange={(e) => {
          ThirdPartyJobPaymentsAdminItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: ThirdPartyJobPaymentsAdminItem.getSelectedCellHeader,
        orderById: '',
        data: ThirdPartyJobPaymentsAdminItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Third-Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: 'ThirdPartyJobId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      { label: 'Evaluator', orderById: 'EvaluatorName', data: 'EvaluatorName', minWidth: 100 },
      {
        label: 'Client',
        orderById: 'ClientName',
        data: (item) => (
          <LongText
            text={item.ClientName}
            maxLength={30}
          />
        ),
      },
      {
        label: 'Project',
        orderById: 'ProjectId',
        data: (item) => (
          <LongText
            text={item.ProjectIdAndName}
            maxLength={30}
          />
        ),
        minWidth: 100,
      },
      { label: 'Type', orderById: 'TypeText', data: 'TypeText', minWidth: 120 },
      {
        data: (item) => (
          <LookupText
            lookupId={45}
            value={item.StatusCodeLookupValue}
          />
        ),
        label: 'Status',
        orderById: 'StatusCodeLookupValue',
      },
      // CD-5421: sits directly after Status on purpose - it is what explains a Closed payment.
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
      { label: 'Fee', orderById: 'FeeDisplay', data: 'FeeDisplay', minWidth: 50 },
      { label: 'Fee Addit.', orderById: 'FeeAdjustment', data: 'FeeAdjustment', minWidth: 50 },
      { label: 'Expense', orderById: 'Expense', data: 'Expense', minWidth: 50 },
      { label: 'Tax', orderById: 'Vat', data: 'Vat', minWidth: 50 },
      { label: 'Completed On', orderById: 'JobDate', data: 'JobDate', minWidth: 50 },
      { label: 'Created On', orderById: 'CreatedOnUtc', data: 'CreatedOnUtc', minWidth: 50 },
      {
        label: 'Location',
        orderById: 'ThirdPartyLocationName',
        data: (item) => (
          <LongText
            text={item.ThirdPartyLocationName == null ? '' : item.ThirdPartyLocationName}
            maxLength={30}
          />
        ),
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'ThirdPartyLocationCountry',
        data: (item) => <CountryText Code={item.ThirdPartyLocationCountry} />,
        minWidth: 50,
      },
      {
        label: ' ',
        orderById: '',
        data: ThirdPartyJobPaymentsItem.getActionCellContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }
}
